export default __webpack_public_path__ + "static/media/empty_attention.aed595d3.png";